import { ApiKeyInflection, ApiVersion } from 'lib/constants/api';
import { EventName } from 'lib/constants/events';
import { ApiModel, ApiRelationship, ApiResource } from 'lib/interfaces/api';

export enum WebhookStatus {
  Enabled = 'enabled',
  Disabled = 'disabled',
}

export interface WebhookAttributes {
  'environment-id'?: string;
  url?: string;
  status?: WebhookStatus;
  secrets?: string[];
  'api-version'?: ApiVersion;
  'api-key-inflection'?: ApiKeyInflection;
  'api-attributes-blocklist'?: string[];
  'included-blocklist'?: string[];
  'relationship-blocklist'?: string[];
  'custom-http-headers'?: Record<string, string>;
  'file-access-token-expires-in'?: number;
  'enabled-events'?: EventName[];
  'payload-filter'?: Record<string, unknown>;
  'created-at'?: string;
}

export interface WebhookRelationships {
  environment: ApiRelationship<ApiModel.EnvironmentSandbox | ApiModel.EnvironmentProduction>;
}

export type Webhook = ApiResource<WebhookAttributes, WebhookRelationships, ApiModel.Webhook>;
